// extracted by mini-css-extract-plugin
export var phone = "_1v-0";
export var phoneDragging = "_1v-1";